function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLink, CBadge } from '../index';
import CIcon from '@coreui/icons-react';
import { iconProps } from './CSidebarNavDropdown'; //component - CoreUI / CSidebarNavItem

var CSidebarNavItem = function CSidebarNavItem(props) {
  var children = props.children,
      className = props.className,
      innerRef = props.innerRef,
      name = props.name,
      icon = props.icon,
      fontIcon = props.fontIcon,
      badge = props.badge,
      addLinkClass = props.addLinkClass,
      label = props.label,
      color = props.color,
      rest = _objectWithoutPropertiesLoose(props, ["children", "className", "innerRef", "name", "icon", "fontIcon", "badge", "addLinkClass", "label", "color"]); //render


  var classes = classNames('c-sidebar-nav-item', className);
  var linkClasses = classNames(label ? 'c-sidebar-nav-label' : 'c-sidebar-nav-link', color && "c-sidebar-nav-link-" + color, addLinkClass);
  var routerLinkProps = rest.to && {
    exact: true,
    activeClassName: 'c-active'
  };
  return /*#__PURE__*/React.createElement("li", {
    className: classes,
    ref: innerRef
  }, children || /*#__PURE__*/React.createElement(CLink, _extends({
    className: linkClasses
  }, routerLinkProps, rest), icon && /*#__PURE__*/React.createElement(CIcon, iconProps(icon)), fontIcon && /*#__PURE__*/React.createElement("i", {
    className: "c-sidebar-nav-icon " + fontIcon
  }), name, badge && /*#__PURE__*/React.createElement(CBadge, _extends(_extends({}, badge), {}, {
    text: null
  }), badge.text)));
};

CSidebarNavItem.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  className: PropTypes.string,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.object]),
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  fontIcon: PropTypes.string,
  badge: PropTypes.object,
  addLinkClass: PropTypes.string,
  label: PropTypes.bool,
  name: PropTypes.string,
  color: PropTypes.string
} : {};
export default CSidebarNavItem;